import set from "lodash/fp/set"
import flow from "lodash/fp/flow"
import get from "lodash/get"

import { APP } from "actions/constants"

export default (state, action) => ({
    [APP.SET.LANGUAGE]: set(["app", "language"], action.payload, state),
    [APP.SET.INITIALIZE_USER]: flow(
        set(["app", "user", "username"], get(action, ["payload", "username"])),
        set(["app", "user", "email"], get(action, ["payload", "email"])),
        set(["app", "user", "name"], get(action, ["payload", "name"])),
        set(["app", "user", "isAuthenticated"], true)
    )(state),
    [APP.SET.USER_SIGN_IN]: flow(
        set(["app", "user", "username"], get(action, ["payload", "username"])),
        set(["app", "user", "email"], get(action, ["payload", "email"])),
        set(["app", "user", "name"], get(action, ["payload", "name"])),
        set(["app", "user", "isAuthenticated"], true)
    )(state),
    [APP.SET.USER_SIGN_OUT]: flow(
        set(["app", "user", "username"], null),
        set(["app", "user", "email"], null),
        set(["app", "user", "name"], null),
        set(["app", "user", "isAuthenticated"], false),
        set(["app", "user", "isPhotoUser"], false),
        set(["loaded"], true)
    )(state),
    [APP.SET.USER_ERROR]: flow(
        set(["app", "user", "error"], get(action, ["payload", "error"])),
        set(["loaded"], true)
    )(state),
    [APP.SET.RSVP]: flow(
        set(["app", "rsvp", "allowed"], get(action, ["payload", "allowed"])),
        set(["app", "rsvp", "record"], get(action, ["payload", "record"]))
    )(state),
    [APP.SET.USER_CURRENT]: flow(
        set(["app", "user", "username"], get(action, ["payload", "username"])),
        set(["app", "user", "email"], get(action, ["payload", "email"])),
        set(["app", "user", "name"], get(action, ["payload", "name"])),
        set(["app", "user", "credentials"], get(action, ["payload", "credentials"])),
        set(["app", "user", "userDetail"], get(action, ["payload", "userDetail"])),
        set(["app", "user", "isAuthenticated"], true),
        set(["app", "user", "isPhotoUser"], get(action, ["payload", "isPhotoUser"])),
        set(["loaded"], true)
    )(state),
})
